import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { TMyMeeting } from '@/common/basis/types/database/tmy-meeting';

function App(props: { item: TMyMeeting.CreateItem }) {
  const item = props.item;
  const startTime = useMemo(() => item?.startTime ?? 0, [item?.startTime]);
  const duration = useMemo(() => item?.duration ?? 0, [item?.duration]);
  const { t } = useTranslation();

  return (
    <div className='my-3 flex items-center justify-start rounded-md bg-[rgba(19,20,21,.04)] px-3 py-4 text-[16px]'>
      <div className='w-12'>
        <span>{dayjs(startTime).format(t('DDFormat'))}</span>
      </div>
      <div className='w-12'>
        <span>{dayjs(startTime).format('ddd')}</span>
      </div>
      <div>
        <span>{dayjs(startTime).format('HH:mm')}</span>
        <span>-</span>
        <span>{dayjs(startTime + duration).format('HH:mm')}</span>
      </div>
    </div>
  );
}

export default App;
